

export const HttpType =  {
        GET: 'GET',
        POST: 'POST'
}
